const kudaUsers = [
  "dolapo@tractionapps.co",
  "demilade@tractionapps.co",
  "mayowa@tractionapps.co",
  "tflux2011@gmail.com",
];
export default kudaUsers;
